import 'react';
import { Box } from '@cbhq/cds-web/layout';
import { RemoteImage } from '@cbhq/cds-web/media';
import { jsx } from 'react/jsx-runtime';
const STATIC_ASSETS_URL = 'https://static-assets.coinbase.com/marketing/flags/';
function FlagIcon({
  countryCode: _countryCode,
  size = 32
}) {
  const countryCode = _countryCode?.toUpperCase();
  const flagType = countryCode !== 'GLOBAL' && countryCode !== undefined ? countryCode : 'default_flag';
  const imageSrc = `${STATIC_ASSETS_URL}${flagType}.svg`;
  // Includes border-radius of 2px
  const imageSize = size + 4;
  return /*#__PURE__*/jsx(Box, {
    width: imageSize,
    height: imageSize,
    children: /*#__PURE__*/jsx(RemoteImage, {
      shape: "circle",
      borderColor: "secondary",
      height: imageSize,
      width: imageSize,
      source: imageSrc,
      alt: countryCode
    })
  });
}
export { FlagIcon as default };
//# sourceMappingURL=FlagIcon.js.map
